import { ProductType } from '../constants/productTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineState,
} from '../types';

type LiningColourStatePostProcess = (
  productType: ProductType,
  context: ProductBuilderMachineContext,
  states: ProductBuilderMachineState[],
) => ProductBuilderMachineState[];

export const liningColourPostProcess: LiningColourStatePostProcess = (
  productType,
  context,
  states,
) => {
  const {
    custom: { lining },
  } = context;



  const productTypesAllowed: ProductType[] = ['Curtain', 'Sheer Curtain'];
  if (!productType || !productTypesAllowed.includes(productType)) {
    console.log('❌ Product type not allowed for lining color:', productType);
    return states;
  }

  const result = lining === 'Unlined'
    ? states.filter(state => state !== 'liningColour')
    : states;
    


  return result;
};